import React, { useState } from 'react';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
import { Footer } from './Footer';
import { Dashboard } from '../../pages/Dashboard';
import { TransactionMonitoring } from '../../pages/TransactionMonitoring';
import { TransactionSearch } from '../../pages/TransactionSearch';
import { RoleManagement } from '../../pages/management/RoleManagement';
import { UserManagement } from '../../pages/management/UserManagement';
import { Configurations } from '../../pages/Configurations';
import { TransactionReport } from '../../pages/reports/TransactionReport';
import { TransactionSummaryReport } from '../../pages/reports/TransactionSummaryReport';
import { UserListReport } from '../../pages/reports/UserListReport';
import { UserActivityAuditLog } from '../../pages/reports/UserActivityAuditLog';
import { AuditLog } from '../../pages/AuditLog';
import { ParticipantsList } from '../../pages/participants/ParticipantsList';
import { AddParticipant } from '../../pages/participants/AddParticipant';
import { EditParticipant } from '../../pages/participants/EditParticipant';
interface AppShellProps {
  onLogout: () => void;
}
export function AppShell({
  onLogout
}: AppShellProps) {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [currentPath, setCurrentPath] = useState('dashboard');
  const handleNavigate = (path: string) => {
    setCurrentPath(path);
  };
  const renderContent = () => {
    switch (currentPath) {
      case 'dashboard':
        return <Dashboard data-id="element-90" />;
      case 'transactions/monitoring':
        return <TransactionMonitoring data-id="element-91" />;
      case 'transactions/search':
        return <TransactionSearch data-id="element-92" />;
      case 'management/roles':
        return <RoleManagement data-id="element-93" />;
      case 'management/users':
        return <UserManagement data-id="element-94" />;
      case 'configurations':
        return <Configurations data-id="element-95" />;
      case 'participants/list':
        return <ParticipantsList onNavigate={handleNavigate} data-id="element-96" />;
      case 'participants/add':
        return <AddParticipant onNavigate={handleNavigate} data-id="element-97" />;
      case 'participants/edit':
        return <EditParticipant onNavigate={handleNavigate} data-id="element-98" />;
      case 'reports/transactions':
        return <TransactionReport data-id="element-99" />;
      case 'reports/summary':
        return <TransactionSummaryReport data-id="element-100" />;
      case 'reports/users':
        return <UserListReport data-id="element-101" />;
      case 'reports/user-activity':
        return <UserActivityAuditLog data-id="element-102" />;
      case 'audit-log':
        return <AuditLog data-id="element-103" />;
      default:
        return <div className="flex items-center justify-center h-full" data-id="element-104">
            <div className="text-center p-8" data-id="element-105">
              <h2 className="text-2xl font-semibold text-gray-700 mb-4" data-id="element-106">
                {currentPath.split('/').pop()?.replace(/-/g, ' ')}
              </h2>
              <p className="text-gray-500" data-id="element-107">This page is under construction</p>
            </div>
          </div>;
    }
  };
  return <div className="flex flex-col min-h-screen bg-gray-50" data-id="element-108">
      <Header isAuthenticated={true} onLogout={onLogout} data-id="element-109" />
      <div className="flex flex-1 overflow-hidden" data-id="element-110">
        <Sidebar collapsed={sidebarCollapsed} onToggleCollapse={() => setSidebarCollapsed(!sidebarCollapsed)} onNavigate={handleNavigate} activePath={currentPath} data-id="element-111" />
        <main className="flex-1 overflow-auto p-6" data-id="element-112">{renderContent()}</main>
      </div>
      <Footer data-id="element-113" />
    </div>;
}